module.exports = __webpack_public_path__ + "static/media/filter_list.62d380a0.svg";